module.exports = "module.exports = {\n\t\"frameworks\": {\n\t\t\"net46\": {\n\t\t\t\"dependencies\": {\n\t\t\t\t\"Microsoft.Azure.Amqp\": \"2.0.3\",\n\t\t\t\t\"Microsoft.AspNet.WebApi.Client\": \"5.2.3\",\n\t\t\t\t\"Microsoft.Azure.Devices\": \"1.3.1\",\n\t\t\t\t\"Microsoft.AspNet.WebApi.Core\": \"5.2.3\"\n\t\t\t}\n\t\t}\n\t}\n};"


//////////////////
// WEBPACK FOOTER
// ./src/data/ShakeShake/azureFunction/project.json
// module id = 398
// module chunks = 0